<template>
  <section class="categories-section" :class="{ 'categories-section-mobile': isMobile }">
    <div class="container">
      <div class="services" ref="animateSection">
        <div class="single-service b1" @click="scrollTo('transfer')">
          <img src="/services/transfer.png" alt="">
          <p>
            <a>{{ $t('headerNav.transfer') }}</a>
          </p>
        </div>
        <div class="single-service b2" @click="scrollTo('tours')">
          <img src="/services/tours.png" alt="">
          <p>
            <a>{{ $t('headerNav.tours') }}</a>
          </p>
        </div>
        <div class="single-service b3" @click="scrollTo('carRent')">
          <img src="/services/carRental.png" alt="">
          <p>
            <a>{{ $t('headerNav.carRent') }}</a>
          </p>
        </div>
        <div class="single-service b4" @click="scrollTo('limo')">
          <img src="/services/limo.png" alt="">
          <p>
            <a>{{ $t('headerNav.limoService') }}</a>
          </p>
        </div>
      </div>
    </div>
    <div class="partners">
      <div class="marquee">
        <div class="marquee-content">
          <img v-for="logo in partners" :src="logo.src" :alt="logo.alt" :key="logo.id" class="logo" loading="lazy"
               :style="logo.id === 6 ? { padding: '30px 0', maxWidth: '250px' } : {}">
          <img v-for="logo in partners" :src="logo.src" :alt="logo.alt" :key="logo.id" class="logo" loading="lazy"
               :style="logo.id === 6 ? { padding: '30px 0', maxWidth: '250px' } : {}">
          <img v-for="logo in partners" :src="logo.src" :alt="logo.alt" :key="logo.id" class="logo" loading="lazy"
               :style="logo.id === 6 ? { padding: '30px 0', maxWidth: '250px' } : {}">
          <img v-for="logo in partners" :src="logo.src" :alt="logo.alt" :key="logo.id" class="logo" loading="lazy"
               :style="logo.id === 6 ? { padding: '30px 0', maxWidth: '250px' } : {}">
          <img v-for="logo in partners" :src="logo.src" :alt="logo.alt" :key="logo.id" class="logo" loading="lazy"
               :style="logo.id === 6 ? { padding: '30px 0', maxWidth: '250px' } : {}">
        </div>
      </div>
    </div>
    <div class="why-us">
      <div class="title">{{ $t('whyUs.title') }}</div>
      <div class="tabs">
        <div class="tab tab-first">
          <img src="../assets/images/why-us/twit.png" alt="">
          <p>{{ $t('whyUs.quick') }}</p>
        </div>
        <div class="tab">
          <img src="../assets/images/why-us/plane.png" alt="">
          <p>{{ $t('whyUs.wait') }}</p>
        </div>
        <div class="tab tab-third">
          <img src="../assets/images/why-us/pay.png" alt="">
          <p>{{ $t('whyUs.pay') }}</p>
        </div>
        <div class="tab tab-fourth">
          <img src="../assets/images/why-us/destination.png" alt="">
          <p>{{ $t('whyUs.offer') }}</p>
        </div>
        <div class="tab phone">
          <img src="../assets/images/why-us/phone.png" alt="">
          <a href="tel:+38269904274">{{ $t('whyUs.contact') }}</a>
        </div>
        <div class="tab tab-last">
          <img src="../assets/images/why-us/discount.png" alt="">
          <p>{{ $t('whyUs.scheduling') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CategoriesSection',

  data() {
    return {
      isMobile: false,
      partners: [
        {id: 1, src: './partners/kalamper.png', alt: 'Logo 1'},
        {id: 2, src: './partners/mediteran.png', alt: 'Logo 3'},
        {id: 3, src: './partners/light.png', alt: 'Logo 3'},
        {id: 4, src: './partners/pine.png', alt: 'Logo 12'},
        {id: 5, src: './partners/soa.png', alt: 'Logo 5'},
        {id: 6, src: './partners/splendid.png', alt: 'Logo 14'},
      ]
    };
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.$refs.animateSection.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    }, options);

    observer.observe(this.$refs.animateSection);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 1159;
    },
    scrollTo(sectionId) {
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({behavior: 'smooth'});
      }
    },
    handleScroll() {
      const currentScrollY = window.scrollY;
      if (currentScrollY > this.lastScrollY) {
        // Scrolling down
        this.isHeaderHidden = true;
      } else {
        // Scrolling up
        this.isHeaderHidden = false;
      }
      this.lastScrollY = currentScrollY;
    }
  },
  created() {
    this.checkMobile();
  },

}
</script>

<style lang="scss" scoped>
@import "~@/assets/main.scss";


.categories-section-mobile {
  //padding: 50px 0 !important;
  padding: 30px 0 !important;

  .container {
    .services {
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 100% !important;
      gap: 0px !important;
      flex-wrap: nowrap;

      .single-service {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        img {
          width: 80px !important;
        }

        p, a {
          margin: 0;
          font-family: 'Inter-Regular', 'Inter', sans-serif;
          text-decoration: none;
          text-transform: uppercase;
          color: #fff;
          font-size: 10px !important;
          line-height: 12px !important;
          transition: transform 0.3s ease-out, color 1s ease, text-shadow 1s ease;

          &:hover {
            color: $darker-blue;
            background-color: transparent;
            text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          }
        }
      }
    }

  }

  .partners {
    margin-top: 20px !important;

    .marquee {
      width: 100%;
      overflow: hidden;
      position: relative;
      mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 30%, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0) 100%);
      -webkit-mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 30%, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0) 100%);
    }

    .marquee-content {
      display: flex;
      align-items: center;
      width: calc(100% * 2);
      animation: marquee 20s linear infinite;
    }

    .logo {
      margin-right: 40px !important;
      max-height: 50px !important;
    }

    @keyframes marquee {
      from {
        transform: translateX(0);
      }
      to {
        transform: translateX(-50%);
      }
    }
  }

  .why-us {
    font-family: 'Inter-Regular', 'Inter', sans-serif;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .title {
      font-weight: bold;
      text-transform: uppercase;
      color: white;
      font-size: 20px !important;
      padding: 30px 0px !important;
    }

    .tabs {
      max-width: 100% !important;

      .tab {
        padding: 5px !important;
        max-width: 95px !important;
        max-height: 120px !important;
        gap: 5px !important;
        border-radius: 10px !important;

        img {
          max-width: 30px !important;
        }

        p {
          font-size: 8px !important;
        }

        a {
          text-decoration: none;
          cursor: pointer;
        }

        &-first {
          border-radius: 10px !important;
        }

        &-third {
          border-radius: 10px !important;
        }

        &-fourth {
          border-radius: 10px !important;
        }

        &-last {
          border-radius: 10px !important;
        }
      }

      .phone {
        background-color: $primary-blue !important;

        a {
          padding: 5px 15px !important;
          border-radius: 10px !important;
          width: 50% !important;
          font-size: 8px !important;
          margin-top: 3px;
        }
      }
    }
  }

  &__content {
    display: flex;
    width: 100%;
    justify-content: space-around;
  }

}

.categories-section {
  padding: 100px 0;
  // opacity: 0;

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    //max-width: 80%;
    flex-direction: column;

    .services {
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 80%;

      .single-service {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        transition: transform 0.4s ease-out, opacity 0.6s ease-in !important;
        will-change: transform !important;
        cursor: pointer;

        img {
          width: 319px;
        }

        p a {
          font-family: "Inter", sans-serif;
          text-decoration: none;
          text-transform: uppercase;
          color: #fff;
          font-size: 25px;
          font-weight: 300;
          line-height: 0;
        }

        &:hover {
          transform: scale(0.95) translateY(0px) !important;
          transition: transform 0.3s ease-out !important;
          //  border: 1px solid $primary-blue;
          border-radius: 30px;
          box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.7) !important;
        }

        &:active {
          transform: scale(0.9) !important;
          box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.8) !important;
        }
      }

      &.animate {
        opacity: 1;

        .b1 {
          animation: slideInFromBottom 2s forwards;
        }

        .b2 {
          animation: slideInFromBottom 2.75s forwards;
        }

        .b3 {
          animation: slideInFromBottom 3.5s forwards;
        }

        .b4 {
          animation: slideInFromBottom 4.25s forwards;
        }
      }

      @keyframes slideInFromBottom {
        0% {
          transform: translateY(100%);
          opacity: 0;
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }
    }
  }

  .partners {
    margin-top: 100px;

    .marquee {
      width: 100%;
      overflow: hidden;
      position: relative;
      mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 30%, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0) 100%);
      -webkit-mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 30%, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0) 100%);
    }

    .marquee-content {
      display: flex;
      align-items: center;
      width: calc(100% * 2);
      animation: marquee 20s linear infinite;
    }

    .logo {
      margin-right: 100px;
      max-height: 100px;

      @include respond(from-phone-to-tab) {
        height: 60px;
      }
    }

    @keyframes marquee {
      from {
        transform: translateX(0);
      }
      to {
        transform: translateX(-50%);
      }
    }
  }

  .why-us {
    font-family: 'Inter-Regular', 'Inter', sans-serif;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .title {
      font-size: 80px;
      font-weight: bold;
      text-transform: uppercase;
      color: white;
      padding: 100px 0 50px;
    }

    .tabs {
      max-width: 80%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 20px;

      &:hover .tab {
        filter: blur(5px);
      }

      .tab {
        background-color: #FFFFFF;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;
        max-width: 450px;
        max-height: 450px;
        width: 300px;
        height: 300px;
        gap: 30px;
        transition: transform 0.3s ease-out, filter 0.3s ease;
        will-change: transform;

        img {
          max-width: 140px;
        }

        p {
          font-size: 20px;
          text-align: center;
          font-weight: bold;
          color: #1E1E1E;
          max-width: 90%;
        }

        &-first {
          border-radius: 30px 0 0 0;
        }

        &-third {
          border-radius: 0 30px 0 0;
        }

        &-fourth {
          border-radius: 0 0 0 30px;
        }

        &-last {
          border-radius: 0 0 30px 0;
        }

        &:hover {
          transform: scale(1.1);
          //border-radius: 30px;
          filter: blur(0);
        }
      }

      .phone {
        background-color: $primary-blue !important;

        a {
          color: white;
          padding: 15px 20px;
          border-radius: 15px;
          border: 2px solid rgba(245, 245, 245, 0.6509803922);
          width: 70%;
          text-transform: uppercase;
          cursor: pointer;
          text-decoration: none;
          font-size: 20px;
          text-align: center;
          font-family: Inter, sans-serif;
          font-weight: 600;

          &:hover {
            // background-color: $darker-blue !important;
            box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.8) !important;
          }
        }

      }
    }
  }

  &__content {
    display: flex;
    width: 100%;
    justify-content: space-around;
  }

}
</style>
